module.exports = "<div class=row> <pagination> <pagination-item prev disabled=disabled></pagination-item> <pagination-item v-for=\"page in pages\" :active=\"page == current\" @click=setCurrent(page)> {{page}} </pagination-item> <pagination-item next></pagination-item> </pagination> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/pagination/pagination-demo.vue
 ** module id = 343
 ** module chunks = 0
 **/